import { tns } from 'tiny-slider/src/tiny-slider';

export default (() => {

  window.instancesQuickLinksTwo = [];
  
    $('.quick-links-2').not('.no-slides').each(function(i) {
        window.instancesQuickLinksTwo.push(tns({
            container: $(this)[0],
            autoplay: false,
            autoplayButtonOutput: false,
            speed: 1000,
            touch: true,
            controls: true,
            controlsText: ['<i class="fal fa-chevron-left"></i>', '<i class="fal fa-chevron-right"></i>'],
            nav: false,
            loop: false,
            gutter: 20,
            responsive: {
                1: {
                  items: 1,
                },
                768: {
                    items: 2,
                },
                1200: {
                    items: 3,
                },
              },
        }));

        $(this).find('.first-mobile').click(function() {
          window.instancesQuickLinksTwo[i].goTo('first');
        })

        $(this).find('.next-mobile').click(function() {
            window.instancesQuickLinksTwo[i].goTo('next');
        });
    });
});



// WEBPACK FOOTER //
// ./scripts/components/quick-links-2.js